module.exports = __webpack_public_path__ + "static/media/006.76012caa.jpg";